import { Component, EventEmitter, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { InfosPatient } from 'src/app/utils/interfaces/new/infos-patient.interface';

const PASSPHRASE_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/;

export interface FusionPassphrase {
  isValid: boolean;
  isEmpty: boolean;
  passphrase: string;
}

export enum FussionOrUnfusionEnum {
  FUSION = 'fusion',
  UNFUSION = 'unfusion',
}

@Component({
  selector: 'app-fusion-passphrase',
  templateUrl: './fusion-passphrase.fragment.html',
  styleUrls: [
    './fusion-passphrase.fragment.scss',
    '../../../../../../fragments/modal/modal.fragment.scss'
  ]
})
export class FusionPassphraseFragment implements OnInit {

  public formGroup: FormGroup;
  public sourcePatient: InfosPatient;
  public targetPatient: InfosPatient;
  public fussionOrUnfusion: FussionOrUnfusionEnum;
  public fussionOrUnfusionTpl = FussionOrUnfusionEnum;
  private _isPassphraseError = false;
  public get isPassphraseError(): boolean {
    return this._isPassphraseError;
  }
  public set isPassphraseError(value: boolean) {
    this._isPassphraseError = value;
    if (value) {
      this.isPassphraseNoError = true;
    }
  }
  public isPassphraseNoError = false;

  public closeEmitter = new EventEmitter<FusionPassphrase | undefined>();

  constructor(
    private _formBuilder: FormBuilder,
  ) { }

  ngOnInit(): void {
    this.formGroup = this._formBuilder.group({
      passphrase: ['', [Validators.required, Validators.minLength(1)]],
    });

    this.formGroup.get('passphrase')?.valueChanges.subscribe((value: string) => {
      if (this.isPassphraseError === true) {
        if (this._isPasswordStrong(this.formGroup.get('passphrase').value)) {
          this.isPassphraseError = false;
        }
      } else if (this.isPassphraseNoError === true) {
        this.isPassphraseError = !this._isPasswordStrong(this.formGroup.get('passphrase').value);
      }
    });
  }

  public cancel(): void {
    this.closeEmitter.emit(undefined);
  }

  public onSubmit(): void {
    if (this.formGroup.valid && this.formGroup.get('passphrase')?.value && this.formGroup.get('passphrase')?.value !== "") {
      if (!this._isPasswordStrong(this.formGroup.get('passphrase').value)) {
        this.isPassphraseError = true;
        return;
      }

      this.closeEmitter.emit({
        isValid: true,
        isEmpty: false,
        passphrase: this.formGroup.get('passphrase').value,
      });
    }
  }

  private _isPasswordStrong(password: string): boolean {
    return PASSPHRASE_REGEX.test(password);
  }
  

}
